export const AuthType = {
  Classic: "classic",
  Sso: "sso",
  OAuth: "oauth",
} as const

export type TAuthType = (typeof AuthType)[keyof typeof AuthType]

export function getAuthType(): TAuthType {
  return AuthType.Sso
}
